/* eslint-disable react-perf/jsx-no-new-object-as-prop */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
/* eslint-disable simple-import-sort/imports */
import { useRouter } from 'next/router';

import { Box, BoxProps } from '@cbhq/cds-web/layout/Box';
import { Sidebar } from '@cbhq/cds-web/navigation/Sidebar';
import { SidebarItem } from '@cbhq/cds-web/navigation/SidebarItem';

import useIsMobile from ':support/hooks/useIsMobile';
import { useDynamicConfig } from ':support/providers/DynamicConfigProvider';

type ContainerProps = BoxProps<'div'> & {
  children: React.ReactNode;
  hideSideMenu?: boolean;
};

const containerStyles = { marginLeft: 'auto', marginRight: 'auto', display: 'flex' };

const sideBarStyles = { paddingTop: '1.75rem', paddingRight: '2rem' };

export const ROUTES = {
  ACCOUNT: '/account',
  SUPPORT: '/',
  THREADS: '/threads/[threadId]',
  CASES: '/cases/[caseId]',
  CREATE_CASE: '/create-case',
} as const;

export function Container({ children, hideSideMenu, ...props }: ContainerProps) {
  const router = useRouter();
  const handleNavigation = async (path: string) => router.push(path);
  const isMobile = useIsMobile();
  const { showAdminHub } = useDynamicConfig();

  return (
    <Box
      width="100%"
      maxWidth={1280}
      paddingX={4}
      flexGrow={1}
      style={{
        ...containerStyles,
      }}
      {...props}
    >
      {!hideSideMenu && !isMobile && showAdminHub ? (
        <Box style={sideBarStyles}>
          <Sidebar>
            <SidebarItem
              onClick={async () => handleNavigation('/')}
              title="Support"
              icon="support"
              active={
                router.pathname === ROUTES.SUPPORT ||
                router.pathname === ROUTES.THREADS ||
                router.pathname === ROUTES.CASES ||
                router.pathname === ROUTES.CREATE_CASE
              }
            />
            <SidebarItem
              onClick={async () => handleNavigation('/account')}
              title="Account"
              icon="account"
              active={router.pathname === ROUTES.ACCOUNT}
            />
          </Sidebar>
        </Box>
      ) : null}
      {children}
    </Box>
  );
}
